/**
 * Session management utilities
 */

const SESSION_KEY = 'wt_session_id';
const SESSION_DURATION = 30 * 60 * 1000; // 30 minutes

/**
 * Generate a unique session ID
 */
export function generateSessionId(): string {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
}

/**
 * Get current session ID from storage
 */
export function getSessionId(): string | null {
  try {
    const stored = localStorage.getItem(SESSION_KEY);
    if (!stored) return null;

    const { id, timestamp } = JSON.parse(stored);

    // Check if session has expired
    if (Date.now() - timestamp > SESSION_DURATION) {
      localStorage.removeItem(SESSION_KEY);
      return null;
    }

    // Update timestamp to extend session
    localStorage.setItem(
      SESSION_KEY,
      JSON.stringify({ id, timestamp: Date.now() })
    );

    return id;
  } catch {
    return null;
  }
}

/**
 * Store session ID
 */
export function setSessionId(sessionId: string): void {
  try {
    localStorage.setItem(
      SESSION_KEY,
      JSON.stringify({
        id: sessionId,
        timestamp: Date.now(),
      })
    );
  } catch {
    // Silently fail if localStorage is not available
  }
}
